import { getPath, getInitialState } from "../../utils";

const initialState = {
  cityList: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activeCity: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CITY_LIST":
      return setCityList(state, action);
    case "SET_ACTIVE_CITY":
      return setActiveCity(state, action);
    case "SET_CURRENT_PAGE_CITY":
      return setCurrentPageCity(state, action);
    case "SET_ACTIVE_CITY_FILTERS":
      return setActiveCityFilters(state, action);
    case "RESET_STATE_CITY":
      return resetState(state, action);
    default:
      return state;
  }
}

const setActiveCity = (state, action) => {
  return {
    ...state,
    activeCity: action.payload,
  };
};

const setCityList = (state, action) => {
  return {
    ...state,
    cityList: getPath(action.payload, "cities", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setCurrentPageCity = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setActiveCityFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
